'use client';

import React, { useEffect, useState } from 'react';
import CartIcon from 'public/assets/icons/shopping-bag-new-icon.svg';
import CartModal from '@/components/Layout/Header/Cart/CartModal';
import useCart from '@/hooks/useCart';
import FlipNumbers from 'react-flip-numbers';
import { trackClick } from '@/helpers/Analytics';
import { useLayout } from '@/contexts/LayoutContext';

const Cart = () => {
    const { cart } = useCart();
    const { showCart, toggleCart, hideCart } = useLayout();
    const [cartCount, setCartCount] = useState<number>(0);

    useEffect(() => {
        const count = cart?.items.reduce((acc, item) => acc + item.quantity, 0) || 0;
        setCartCount(count);
    }, [cart]);

    return (
        <div className="relative">
            <button
                type="button"
                className="flex justify-around items-center text-left bg-white rounded-full p-[4px] ml-[-2px] min-w-[50px] h-[50px] hover:opacity-60"
                onClick={() => {
                    trackClick(showCart ? 'Close Cart' : 'Open Cart')();
                    toggleCart();
                }}
            >
                <CartIcon />
                <div className="mt-[1px] ml-[-2px] font-[500]">
                    <FlipNumbers height={13} width={9} color="#404A5C" background="white" play={cartCount !== 0} perspective={100} numbers={`${cartCount}`} />
                </div>
            </button>
            <CartModal onHide={() => hideCart()} show={showCart} />
        </div>
    );
};

export default Cart;
